import React, { useContext } from "react"
import classnames from "classnames"
import { X } from "react-feather"

import CartItem from "src/components/core/atoms/cart-item"
import { shadow, isOpen, container, cartHeader, close, cartMain } from "./cartSidebar.module.css"

import { CartContext } from "src/context/CartContext"
import { Button } from 'src/components/core/atoms/button'
import { Link } from 'gatsby'

const CartSidebar = () => {
  const { cartData, sidebarIsOpen, dispatchCart, dispatchSidebar, ACTIONS } = useContext( CartContext )

  return (
    <>
      <div role="none" className={ classnames( shadow, { [ isOpen ]: sidebarIsOpen.sidebar } ) } onClick={ () => dispatchSidebar( { type: ACTIONS.SIDEBAR_IS_OPEN, payload: false } ) } />
      <div className={ classnames( container, { [ isOpen ]: sidebarIsOpen.sidebar } ) } >
        <div className={ cartHeader }>
          <div className={ close }>
            <X onClick={ () => dispatchSidebar( { type: ACTIONS.SIDEBAR_IS_OPEN, payload: false } ) } />
          </div>
          <span>
            <h2>Your items</h2>
            <Button variant="underlined" onClick={ () => dispatchCart( { type: ACTIONS.CART_CLEAR } ) }>clear selection</Button>
          </span>
        </div>
        <div className={ cartMain }>
          { cartData && cartData.length ? cartData.map( item => {
            return <CartItem item={ item } key={ item._id } />
          } ) : <p>There are no items in your cart.</p> }
          <Link to="/services/booking">
            <Button variant="solid" onClick={ () => dispatchSidebar( { type: ACTIONS.SIDEBAR_IS_OPEN, payload: false } ) }>Complete Booking</Button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default CartSidebar
